import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../../hook/useRulesContext";
import { formatApplyToDisplay } from "../../../../../others/helperFunctions";
import ActionDropdown from "../tableBodyElements/ActionDropdown";
import StatusBadge from "../tableBodyElements/StatusBadge";

export default function TableBody() {
    const { currentShortcodes, selectedItems, handleSelectItem } =
        useRulesContext();

    return (
        <tbody className="divide-y divide-gray-200 bg-white">
            {currentShortcodes.map((item) => {
                return (
                    <tr
                        key={item.id}
                        className="hover:bg-gray-50 transition-colors"
                    >
                        <td className="px-4 sm:px-6 py-4">
                            <input
                                type="checkbox"
                                checked={selectedItems.has(item.id)}
                                onChange={(e) =>
                                    handleSelectItem(item.id, e.target.checked)
                                }
                                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                            />
                        </td>
                        <td className="px-3 py-4 whitespace-nowrap">
                            <span className="text-sm text-gray-500">
                                #{item.id}
                            </span>
                        </td>
                        <td className="px-3 py-4 whitespace-nowrap">
                            <div className="text-sm font-medium text-gray-900">
                                {item.name}
                            </div>
                        </td>
                        <td className="px-3 py-4 whitespace-nowrap">
                            {item.rule_priority}
                        </td>
                        <td className="px-3 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-500">
                                {formatApplyToDisplay(item)}
                            </div>
                        </td>
                        <td className="px-3 py-4 whitespace-nowrap">
                            {item.min_quantity}
                        </td>
                        <td className="px-3 py-4 whitespace-nowrap">
                            {item.max_quantity}
                        </td>
                        <td className="px-3 py-4 whitespace-nowrap">
                            {item.step}
                        </td>
                        <td className="px-3 py-4 whitespace-nowrap">
                            {item.default_quantity}
                        </td>
                        <td className="px-3 py-4 whitespace-nowrap">
                            <StatusBadge status={item.rule_status} />
                        </td>
                        <td className="px-3 py-4 whitespace-nowrap text-right">
                            <ActionDropdown item={item} />
                        </td>
                    </tr>
                );
            })}
        </tbody>
    );
}
